var combinedarray;

const getSwatchesImages = () => {
  const urls = [
    "/collections/all/products?page=1&limit=1000",
    "/collections/all/products?page=2&limit=1000",
    "/collections/all/products?page=3&limit=1000",
    "/collections/all/products?page=4&limit=1000",
  ];

  const dataImages = [];

  return Promise.all(
    urls.map((url) =>
      fetch(url)
        .then((res) => res.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const elements = doc.querySelectorAll(".json-product-images");

          elements.forEach((el) => {
            const dataAttr = el.getAttribute("data-image");
            if (dataAttr) {
              try {
                const jsonData = JSON.parse(dataAttr);
                dataImages.push(...jsonData);
              } catch (e) {
                //console.error("Error al parsear JSON en", url, e);
              }
            }
          });
        })
        .catch((err) => {
          //console.error("Error al obtener datos de:", url, err);
        })
    )
  ).then(() => dataImages);
};

function createswatches() {
  const urls = [
    "/collections/all/products.json?page=1&limit=1000",
    "/collections/all/products.json?page=2&limit=1000",
    "/collections/all/products.json?page=3&limit=1000",
    "/collections/all/products.json?page=4&limit=1000",
  ];

  Promise.all(
    urls.map((url) => fetch(url).then((response) => response.json()))
  ).then((data) => {
    var firstdataset = data[0].products;
    combinedarray = firstdataset.concat(
      data[1].products,
      data[2].products,
      data[3].products
    );

    assignswatches(combinedarray);
  });
}

function assignswatches(combinedarray) {
  document.querySelectorAll(".productgriditem").forEach((element, index) => {
    var loop = 0;
    var ptitle = element.getAttribute("data-product-title");
    var pid = element.getAttribute("data-product-id");

    combinedarray.forEach((product) => {
      if (product.title == ptitle) {
        loop += 1;

        var productid = product.id;
        var image = product.images[0].src;
        var producthandle = product.handle;
        var variant = product.variants[0].title;
        var colorsplit = variant.split(" / ");
        var color = colorsplit[0];
        var colorhandleized = color
          .toLowerCase()
          .replace(/ /g, "-")
          .replace(/\//g, "-");

        var collectionurl = `/collections/${collectionhandle}/products/${producthandle}`;

        const swatches_data = window.swatchesImages || [];
        const dataImagesExt = swatches_data.find(
          (item) => item.id == productid
        );

        console.log("dataImagesExt", dataImagesExt, swatches_data);

        const swatchUpdatedBG = dataImagesExt
          ? dataImagesExt.swatch_image
          : `${swatchurl}${colorhandleized}_50x.png`;

        var swatchitem = `
          <a reference="${productid}" href="${collectionurl}" class="swatch-link">
              <span data-variant-color="${color}" data-url="${collectionurl}" 
                class="variantcolor collectionswatch color-swatch color-swatch-collection color-swatch--small color-swatch--${colorhandleized} color-swatch--with-image" data-tooltip="${color}" data-variant-image="${image}&width=500" style="background-image: url('${swatchUpdatedBG}'); background-color: ${color};" data-uw-styling-context="true">
                  <span class="visually-hidden" data-uw-styling-context="true">${color}</span>
              </span>
          </a>`;

        var colorGrid = document.querySelector(
          `.colorgrid${pid}:not(.swatchadded${colorhandleized})`
        );

        if (colorGrid) {
          // PRIMERO: Añadir el swatch actual
          colorGrid.insertAdjacentHTML("beforeend", swatchitem);
          colorGrid.classList.add(`swatchadded${colorhandleized}`);

          // DESPUÉS: Verificar si necesitamos manejar morecolorsct
          const currentSwatches = colorGrid.querySelectorAll(".swatch-link");
          const swatchCount = currentSwatches.length;

          // Si tenemos más de 4 swatches, ocultar los extras y manejar morecolorsct
          if (swatchCount > 4) {
            // Ocultar swatches del 5to en adelante
            currentSwatches.forEach((swatch, index) => {
              if (index >= 4) {
                swatch.style.display = "none";
              }
            });

            // Verificar si ya existe morecolorsct
            let existingMoreColors = colorGrid.querySelector(".morecolorsct");
            
            if (!existingMoreColors && swatchCount === 5) {
              // Primera vez que llegamos a 5 swatches - añadir morecolorsct
              colorGrid.insertAdjacentHTML(
                "beforeend",
                '<span class="morecolorsct" style="cursor:pointer;"><span class="colornumber">+1</span></span>'
              );
            } else if (existingMoreColors) {
              // Ya existe morecolorsct - solo actualizar el contador
              var extraCount = swatchCount - 4;
              existingMoreColors.innerHTML = `<span class="colornumber">+${extraCount}</span>`;
            }
          }

          const parent = colorGrid.parentNode;
          const childReference = parent.querySelector(
            ".grid-product__image-mask"
          );

          const swatchLink = colorGrid.querySelector(
            `a[reference="${productid}"]`
          );

          const toggleImageOnHover = (type) => {
            type === "enter"
              ? childReference.classList.add("hovered")
              : childReference.classList.remove("hovered");

            const imageOnHover = `<img src="${image}" alt="${color}" class="swatch-hover-image" />`;
 
            if (type === "enter") {
              childReference.insertAdjacentHTML("beforeend", imageOnHover);
            } else {
              const hoverImages = parent?.querySelectorAll(
                ".swatch-hover-image"
              );
              hoverImages.forEach((hoverImage) => {
                hoverImage.classList.add("fade-out");
                setTimeout(() => hoverImage.remove(), 300);
              });
            }
          };

          swatchLink.addEventListener("mouseenter", function () {
            toggleImageOnHover("enter");
          });

          swatchLink.addEventListener("mouseleave", function () {
            toggleImageOnHover("leave"); 
          });
        }
      }
    });
  });

  
  assignViewMoreSwatches()
}

const assignViewMoreSwatches = () => {
  const button = document.querySelectorAll("span.morecolorsct");
  button.forEach((btn) => {
    btn.addEventListener("click", function () {
      const parent = this.parentNode;
      const swatches = parent.querySelectorAll(".swatch-link");
      swatches.forEach((swatch) => {
        swatch.style.display = "inline-block";
      });

      btn.style.display = "none";
    });
  });
}




getSwatchesImages().then((images) => {
  window.swatchesImages = images;
  createswatches();

});

